<template>
	<div class="index">
		<div class="custom-tabbar-page">
			<div class="profile-page tn-safe-area-inset-bottom">
				<div class="top-backgroup">
					<div class="header-bg">
						<div class="header-content">
							<div class="welcome-text">{{ $t('mine.welcome_back') }}</div>
							<div class="subtitle">{{ $t('mine.welcome_subtitle') }}</div>
						</div>
					</div>
				</div>

				<div class="page-content tn-margin-left tn-margin-right">

					<div class="user-card">
						<div class="user-info">
							<div class="avatar-section">
								<div class="avatar-wrapper">
									<img class="avatar-img" :src="currentAvatar" alt="" />
								</div>
								<div class="user-details">
									<div class="user-name-row">
										<div class="user-phone">
											{{ userInfo.username }}
										</div>
									</div>
									<div class="credit-section">
										<div class="credit-header">
											<div class="credit-label">
												{{ $t('common.credit_score') }}
											</div>
											<div class="credit-score">
												100/{{ userInfo.xinyu }}
											</div>
										</div>
										<van-progress :percentage="100" :show-pivot="false" />
									</div>
								</div>
							</div>

							<div class="setting-btn" @click="$router.push({path:'/Setting'});">
								<span class="tn-icon-install"></span>
							</div>
						</div>
					</div>

					<div class="quick-actions">
						<div class="action-btn recharge" @click="$router.push({path:'/Recharge'});">
							<div class="btn-icon">
								<div class="icon-text">💰</div>
							</div>
							<div class="btn-text">
								{{ $t('recharge.page_title') }}
							</div>
							<span class="btn-arrow tn-icon-right"></span>
						</div>
						<div class="action-btn withdraw" @click="$router.push({path:'/Withdraw'});">
							<div class="btn-icon">
								<div class="icon-text">💳</div>
							</div>
							<div class="btn-text">
								{{ $t('withdraw.page_title') }}
							</div>
							<span class="btn-arrow tn-icon-right"></span>
						</div>
					</div>

					<div class="balance-section">
						<div class="balance-card">
							<div class="balance-header">
								<div class="balance-label">
									{{ $t('assets.account_balance') }}
								</div>
								<span class="refresh-btn tn-icon-refresh" style="display: none;"></span>
							</div>

							<div class="balance-value">
								<div class="balance-amount">
									€{{ userInfo.money }}
								</div>
							</div>
						</div>
					</div>

					<div class="menu-section">
						<div class="section-title"></div>
						<div class="menu-list">
							<div class="menu-item" @click="$router.push({path:'/Assets'});">
								<div class="menu-left">
									<div class="menu-icon bg-indigo">
										<span class="tn-icon-count-fill"></span>
									</div>
									<div class="menu-name">
										{{ $t('assets.details_title') }}
									</div>
								</div>
								<span class="menu-arrow tn-icon-right"></span>
							</div>

							<div class="menu-item" @click="$router.push({path:'/TaskList'});">
								<div class="menu-left">
									<div class="menu-icon bg-red">
										<span class="tn-icon-notebook-fill"></span>
									</div>
									<div class="menu-name">
										{{ $t('task.inventory_record') }}
									</div>
								</div>
								<span class="menu-arrow tn-icon-right"></span>
							</div>

							<div class="menu-item" @click="$router.push({path:'/RechargeList'});">
								<div class="menu-left">
									<div class="menu-icon bg-blue">
										<span class="tn-icon-coupon-fill"></span>
									</div>
									<div class="menu-name">
										{{ $t('recharge.records_title') }}
									</div>
								</div>
								<span class="menu-arrow tn-icon-right"></span>
							</div>

							<div class="menu-item" @click="$router.push({path:'/WithdrawList'});">
								<div class="menu-left">
									<div class="menu-icon bg-green">
										<span class="tn-icon-lucky-money-fill"></span>
									</div>
									<div class="menu-name">
										{{ $t('withdraw.records_title') }}
									</div>
								</div>
								<span class="menu-arrow tn-icon-right"></span>
							</div>

							<div class="menu-item" @click="$router.push({path:'/Notice'});">
								<div class="menu-left">
									<div class="menu-icon bg-purple">
										<span class="tn-icon-bankcard-fill"></span>
									</div>
									<div class="menu-name">
										{{ $t('notice.page_title') }}
									</div>
								</div>
								<span class="menu-arrow tn-icon-right"></span>
							</div>

							<div class="menu-item" @click="openLanguage">
								<div class="menu-left">
									<div class="menu-icon bg-pink">
										<span class="tn-icon-sequence"></span>
									</div>
									<div class="menu-name">
										{{ $t('common.language_select') }}
									</div>
								</div>
								<span class="menu-arrow tn-icon-right"></span>
							</div>
						</div>
					</div>
				</div>

				<Language ref="languagePicker" @change="handleLanguageChange" />
				<div class="tn-tabbar-height"></div>
			</div>
		</div>
	</div>
</template>

<script>
	import Language from '@/common/Language.vue';

	export default {
		components: {
			Language,
		},
		data() {
			return {
				userInfo: {},
				menu_top: 40,
				isLoading: false,
				lang: localStorage.getItem('lang') || 'de',
			};
		},
		computed: {
			currentAvatar() {
				return this.formatAvatar(this.userInfo.header_img);
			}
		},
		methods: {
			formatAvatar(path) {
				if (!path) {
					return '/img/mine/1.png';
				}
				if (/^(https?:)?\/\//.test(path) || path.startsWith('/')) {
					return path;
				}
				return `/${path.replace(/^\/+/, '')}`;
			},
			openLanguage() {
				this.$refs.languagePicker.open();
			},
			handleLanguageChange(payload) {
				this.lang = payload.code;
			},
			refresh() {
				this.isLoading = true;
				setTimeout(() => {
					this.isLoading = false;
					if (localStorage.getItem('token')) {
						this.$toast(this.$t("reservation.refresh"));
					} else {
						this.$router.push({
							path: '/Login'
						})
					}
				}, 500);
			},
			exit() {
				this.$toast(this.$t("my.finish_task"));
			},
			showSetting() {
				if (localStorage.getItem('token')) {
					this.$router.push({
						path: '/Setting'
					})
				} else {
					this.$router.push({
						path: '/Login'
					})
				}
			},
			toNotice() {
				if (localStorage.getItem('token')) {
					this.$router.push({
						path: '/Notice'
					})
				} else {
					this.$router.push({
						path: '/Login'
					})
				}
			},
			onRefresh() {
				setTimeout(() => {
					this.isLoading = false;
					if (localStorage.getItem('token')) {
						this.getUserInfo();
						this.$toast(this.$t("reservation.refresh"));
					} else {
						this.$router.push({
							path: '/Login'
						})
					}
				}, 500);
			},
			doLogin() {
				if (localStorage.getItem('token')) {
					this.$router.push({
						path: '/Infomation'
					});
				} else {
					this.$router.push({
						path: '/Login'
					})
				}
			},
			doPay() {
				this.$router.push({
					name: 'Recharge',
					params: {
						'balance': this.userInfo.money
					}
				})
			},
			doWithdrawal() {
				this.$http({
					method: 'get',
					url: 'user_get_bank'
				}).then(res => {
					if (res.data.is_bank) {
						this.$router.push("withdraw");
					} else {
						this.$router.push("Setbank");
						this.$toast.fail(this.$t("setting.set_bank"));
					}
				})
			},
			toService() {
				console.log(this.$store.getters.getBaseInfo)
				if (this.$store.getters.getBaseInfo.iskefu == 1) {
					this.$router.push("Withdraw");
				} else {
					this.$toast.fail(this.$t("setting.forbid"));
				}
			},
			getUserInfo() {
				this.$http({
					method: 'get',
					url: 'user_info'
				}).then(res => {
					if (res.code === 200) {
						this.userInfo = res.data;
						console.log(this.userInfo, "this.userInfo---174");
						this.menu_top = 15;
						if (this.userInfo.status !== 1) {
							this.$toast(this.$t("video.account_out"));
							localStorage.clear()
							this.$router.push({
								path: '/Login'
							})
						}
					} else if (res.code === 401) {
						this.$toast(res.msg);
					}
				})
			},

		},
		created() {
			if (localStorage.getItem('token')) {
				this.getUserInfo();
			} else {
				this.userInfo.username = this.$t("setting.log_reg");
				this.userInfo.ip = this.$t("setting.more_service");
				this.userInfo.header_img = "/img/mine/1.png";
			}
		}
	};
</script>

<style scoped lang="less">
	.index {
		width: 100%;
		height: 100vh;
		position: relative;
		background-color: #f2f2f2;
	}

	.index .custom-tabbar-page {
		width: 100%;
		height: calc(100vh - 62px);
		box-sizing: border-box;
		padding-bottom: 0px;
		padding-bottom: calc(0px + constant(safe-area-inset-bottom));
		padding-bottom: calc(0px + env(safe-area-inset-bottom));
	}

	.profile-page {
		background: linear-gradient(180deg, #f8f9fa, #f2f2f5);
		min-height: 100vh
	}

	/* 顶部背景 */
	.top-backgroup {
		height: 145px;
		background: linear-gradient(135deg, #667eea, #764ba2);
		border-radius: 0 0 20px 20px;
		position: relative;
		overflow: hidden
	}

	.top-backgroup::before {
		content: "";
		position: absolute;
		top: -50%;
		right: -20%;
		width: 208px;
		height: 208px;
		background: hsla(0, 0%, 100%, .1);
		border-radius: 50%
	}

	.top-backgroup::after {
		content: "";
		position: absolute;
		bottom: -30%;
		left: -10%;
		width: 156px;
		height: 156px;
		background: hsla(0, 0%, 100%, .08);
		border-radius: 50%
	}

	.top-backgroup .header-content {
		padding: 31px 20px;
		position: relative;
		z-index: 1
	}

	.top-backgroup .header-content .welcome-text {
		display: block;
		font-size: 22px;
		font-weight: 700;
		color: #fff;
		margin-bottom: 6px
	}

	.top-backgroup .header-content .subtitle {
		font-size: 12px;
		color: hsla(0, 0%, 100%, .8)
	}

	/* 页面内容 */
	.page-content {
		margin-top: -52px;
		position: relative;
		z-index: 10;
		padding-bottom: 20px
	}

	.tn-margin-left {
		margin-left: 15px;
	}

	.tn-margin-right {
		margin-right: 15px;
	}

	/* 用户卡片 */
	.user-card {
		background: #fff;
		border-radius: 12px;
		padding: 15px;
		margin-bottom: 15px;
		box-shadow: 0 4px 15px rgba(0, 0, 0, .08)
	}

	.user-card .user-info {
		display: flex;
		align-items: center;
		justify-content: space-between
	}

	.user-card .user-info .avatar-section {
		display: flex;
		align-items: center;
		flex: 1
	}

	.user-card .user-info .avatar-section .avatar-wrapper {
		position: relative;
		margin-right: 12px
	}

	.user-card .user-info .avatar-section .avatar-wrapper .avatar-img {
		width: 62px;
		height: 62px;
		border-radius: 50%;
		border: 2px solid #fff;
		box-shadow: 0 2px 8px rgba(0, 0, 0, .15)
	}

	.user-card .user-info .avatar-section .user-details {
		flex: 1
	}

	.user-card .user-info .avatar-section .user-details .user-name-row {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		gap: 6px;
		margin-bottom: 6px
	}

	::v-deep .van-progress {
		display: inline-flex;
		align-items: center;
		width: 100%;
		overflow: hidden;
		background: #f0f0f0;
		border-radius: 52px;
		height: 6px;
	}

	::v-deep .van-progress__portion {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-items: flex-end;
		justify-content: space-around;
		width: 0;
		height: 100%;
		font-size: 10px;
		color: #fff;
		background-color: #01beff;
		transition: all .3s ease;
		background-image: linear-gradient(45deg, hsla(0, 0%, 100%, .15) 25%, transparent 0, transparent 50%, hsla(0, 0%, 100%, .15) 0, hsla(0, 0%, 100%, .15) 75%, transparent 0, transparent);
		background-size: 41px 41px;
		-webkit-animation: progress-striped-data-v-5a63c194 2s linear infinite;
		animation: progress-striped-data-v-5a63c194 2s linear infinite;
		width: 100%;
		background-color: rgb(102, 126, 234);
	}

	@-webkit-keyframes progress-striped-data-v-5a63c194 {
		0% {
			background-position: 0 0
		}

		100% {
			background-position: 41px 0
		}
	}

	@keyframes progress-striped-data-v-5a63c194 {
		0% {
			background-position: 0 0
		}

		100% {
			background-position: 41px 0
		}
	}

	.user-card .user-info .avatar-section .user-details .user-phone {
		display: block;
		font-size: 16px;
		font-weight: 700;
		color: #333
	}

	.user-card .user-info .avatar-section .user-details .level-badge {
		background: linear-gradient(135deg, #f093fb, #f5576c);
		padding: 2px 9px;
		border-radius: 10px;
		box-shadow: 0 1px 4px rgba(245, 87, 108, .3)
	}

	.user-card .user-info .avatar-section .user-details .level-badge .level-badge-text {
		font-size: 10px;
		color: #fff;
		font-weight: 600
	}

	.user-card .user-info .avatar-section .user-details .credit-section .credit-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 4px
	}

	.user-card .user-info .avatar-section .user-details .credit-section .credit-header .credit-label {
		font-size: 12px;
		color: #666
	}

	.user-card .user-info .avatar-section .user-details .credit-section .credit-header .credit-score {
		font-size: 12px;
		font-weight: 600;
		color: #667eea
	}

	.user-card .user-info .setting-btn {
		width: 36px;
		height: 36px;
		background: linear-gradient(135deg, #f8f9fa, #e9ecef);
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		box-shadow: 2px 2px 4px rgba(0, 0, 0, .08), -2px -2px 4px hsla(0, 0%, 100%, .8)
	}

	.user-card .user-info .setting-btn .tn-icon-install {
		font-size: 18px;
		color: #667eea
	}

	/* 快捷操作 */
	.quick-actions {
		display: flex;
		gap: 10px;
		margin-bottom: 15px
	}

	.quick-actions .action-btn {
		flex: 1;
		display: flex;
		align-items: center;
		padding: 15px;
		border-radius: 10px;
		box-shadow: 3px 3px 8px rgba(0, 0, 0, .08), -3px -3px 8px hsla(0, 0%, 100%, .8);
		transition: all .3s ease
	}

	.quick-actions .action-btn:active {
		-webkit-transform: scale(.98);
		transform: scale(.98)
	}

	.quick-actions .action-btn.recharge {
		background: linear-gradient(135deg, #19cf8a, #0fb87a)
	}

	.quick-actions .action-btn.withdraw {
		background: linear-gradient(135deg, #fea626, #f09300)
	}

	.quick-actions .action-btn .btn-icon {
		width: 31px;
		height: 31px;
		background: hsla(0, 0%, 100%, .2);
		border-radius: 8px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-right: 10px
	}

	.quick-actions .action-btn .btn-icon .icon-text {
		font-size: 16px
	}

	.quick-actions .action-btn .btn-text {
		flex: 1;
		font-size: 15px;
		color: #fff;
		font-weight: 600
	}

	.quick-actions .action-btn .btn-arrow {
		font-size: 14px;
		color: hsla(0, 0%, 100%, .8)
	}

	/* 功能区域 */
	.balance-section,
	.menu-section {
		background: #fff;
		border-radius: 12px;
		padding: 15px;
		margin-bottom: 15px;
		box-shadow: 0 2px 10px rgba(0, 0, 0, .06)
	}

	/* 账户余额 */
	.balance-card .balance-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 10px
	}

	.balance-card .balance-header .balance-label {
		font-size: 13px;
		color: #666;
		font-weight: 500
	}

	.balance-card .balance-header .refresh-btn {
		font-size: 18px;
		color: #667eea;
		padding: 4px
	}

	.balance-card .balance-value .balance-amount {
		font-size: 24px;
		font-weight: 700;
		color: #333
	}

	.balance-card .frozen-row {
		display: flex;
		align-items: center;
		margin-top: 8px
	}

	.balance-card .frozen-row .frozen-label {
		font-size: 12px;
		color: #999;
		margin-right: 6px
	}

	.balance-card .frozen-row .frozen-amount {
		font-size: 13px;
		font-weight: 600;
		color: #e6a817
	}

	/* 菜单列表 */
	.menu-list .menu-item {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 12px 0;
		border-bottom: 0.5px solid #f2f2f2;
		transition: all .3s ease
	}

	.menu-list .menu-item:last-child {
		border-bottom: none
	}

	.menu-list .menu-item:active {
		background: #f8f9fa;
		margin: 0 -10px;
		padding: 12px 10px;
		border-radius: 6px
	}

	.menu-list .menu-item .menu-left {
		display: flex;
		align-items: center
	}

	.menu-list .menu-item .menu-left .menu-icon {
		width: 29px;
		height: 29px;
		border-radius: 7px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-right: 10px
	}

	.menu-list .menu-item .menu-left .menu-icon.bg-blue {
		background: linear-gradient(135deg, #4facfe, #00f2fe)
	}

	.menu-list .menu-item .menu-left .menu-icon.bg-green {
		background: linear-gradient(135deg, #43e97b, #38f9d7)
	}

	.menu-list .menu-item .menu-left .menu-icon.bg-orange {
		background: linear-gradient(135deg, #fa709a, #fee140)
	}

	.menu-list .menu-item .menu-left .menu-icon.bg-purple {
		background: linear-gradient(135deg, #a8edea, #fed6e3)
	}

	.menu-list .menu-item .menu-left .menu-icon.bg-pink {
		background: linear-gradient(135deg, #ffecd2, #fcb69f)
	}

	.menu-list .menu-item .menu-left .menu-icon.bg-red {
		background: linear-gradient(135deg, #f093fb, #f5576c)
	}

	.menu-list .menu-item .menu-left .menu-icon.bg-indigo {
		background: linear-gradient(135deg, #667eea, #764ba2)
	}

	.menu-list .menu-item .menu-left .menu-icon span {
		font-size: 16px;
		color: #fff
	}

	.menu-list .menu-item .menu-left .menu-name {
		font-size: 14px;
		color: #333
	}

	.menu-list .menu-item .menu-arrow {
		font-size: 14px;
		color: #ccc
	}

	/* 底部安全边距 */
	.tn-tabbar-height {
		min-height: 62px;
		height: calc(72px + env(safe-area-inset-bottom) / 2);
		height: calc(72px + constant(safe-area-inset-bottom))
	}
</style>
